/**
 * ROUTES
 *
 * ===============================================
 *
 * This object depicts the component url structure.
 * It contains a key-value pair of components and their respective URLs
 *
 */

export const Routes = {
  home: "/",
  loans: "/loans",
  investments: "/investments",
  assetManagement: "/asset-management",
  about: "/about",
  contact: "/contact",
  faqs: "/faqs",
  privacy_policy: "/privacy-policy",
};
